import React from "react";
import Wrapper from "./Wrapper";

function Footer() {
  return (
    <footer>
      <Wrapper>
        <p>Movie website built with ReactJS</p>
     </Wrapper>
    </footer>
  );
}

export default Footer;
